export enum DOMAIN {
  PROD = '.imprint.co',
  STG = '.stg.imprintapi.co',
  PREPRD = '.preprd.imprintapi.co',
}

export enum COOKIEKEY {
  JWT = 'jwt',
  SHOWEDU = 'showEDU',
  DEVICEID = 'deviceID',
  CONSUMERUUID = 'consumerUUID',
  REDIRECTED = 'redirected',
  PRODUCT_UUID = 'productUUID',
  LANGUAGE_HEADER = 'Accept-Language',
  ISMULTICARD = 'isMultiCard',
  REAPPLICATION = 'reApplication',
}
